import { Spinner } from '@recipes/ui';
import { lazy, Suspense, type ComponentType } from 'react';

function PageFallback() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center" aria-busy="true">
      <Spinner className="text-muted-foreground" />
    </div>
  );
}

/** Code-split a screen: `lazyPage(() => import('./x'), 'X')` renders the named export. */
export function lazyPage<T extends Record<string, ComponentType>>(
  loader: () => Promise<T>,
  name: keyof T & string,
) {
  const Component = lazy(async () => {
    const mod = await loader();
    return { default: mod[name] as ComponentType };
  });
  return (
    <Suspense fallback={<PageFallback />}>
      <Component />
    </Suspense>
  );
}
